import { Injectable } from '@angular/core';

@Injectable()
export class ColorService {

  constructor() { }

  parseColor(color: string): number[] {
    const rxHex = /#([0-9A-Fa-f]{3}([0-9A-Fa-f]{3})?)/
    const rxRGB = /rgb\((\s*[0-9]{1,3}\s*(,\s*[0-9]{1,3}\s*){2})\)/
    let m, rgbFormatted, format

    if ((m = color.match(rxHex)) != null) {
      const col = m[1]
      if (col.length === 6) {
        const r = parseInt(col.substr(0, 2), 16)
        const g = parseInt(col.substr(2, 2), 16)
        const b = parseInt(col.substr(4, 2), 16)
        rgbFormatted = [r, g, b]
        format = 'hex'
      } else {
        const r = parseInt(col[0] + col[0], 16)
        const g = parseInt(col[1] + col[1], 16)
        const b = parseInt(col[2] + col[2], 16)
        rgbFormatted = [r, g, b]
      }
    } else if ((m = color.match(rxRGB)) != null) {
      const col = m[1]
      rgbFormatted = col.split(',').map(n => parseInt(n.trim(), 10))
      format = 'rgb'
    }

    return rgbFormatted
  }

  toFormat(rgbFormatted: number[], targetFormat: string) {
    switch (targetFormat) {
      default: return
      case 'hex':
        return `#${rgbFormatted.map(n => {
          let hx = n.toString(16)
          if (hx.length < 2) {
            hx = '0' + hx
          }
          return hx
        }).join('')}`

      case 'rgb':
        return `rgb(${rgbFormatted.join(', ')})`
    }
  }

  getBrightness(color: string): number {
    const p = this.parseColor(color)
    if (!p) {
      return 1
    }
    return (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/shared/services/color.service.ts